export const errorApi: any = {
  "api/auth/login": {
    "401": {
      summary: "Credenziali Errate",
      detail: "Le credenziali inserite sono errate",
    },
  },
  "api/auth/register": {
    "403": {
      summary: "Errore",
      detail: "Dominio non consentito",
    },
    "409": {
      summary: "Errore",
      detail: "Email già registrata",
    },
  },
  "api/auth/resend-activation-email": {
    "403": {
      summary: "Info",
      detail: "Deve essere passato 1 minuto dall’ultima richiesta di invio",
      severity: "info",
    },
    "404": {
      summary: "Errore",
      detail: "Email non registrata",
    },
    "409": {
      severity: "info",
      summary: "Forbidden",
      detail: "Account già attivo",
    },
  },
  "api/auth/resend-reset-password-email": {
    "403": {
      summary: "Info",
      detail: "Deve essere passato 1 minuto dall’ultima richiesta di invio",
      severity: "info",
    },
    "404": {
      summary: "Errore",
      detail: "Email non registrata",
    },
    "409": {
      severity: "info",
      summary: "Forbidden",
      detail: "Account già attivo",
    },
  },
  "api/auth/activate-account": {
    "404": {
      summary: "Errore",
      detail: "Token non più valido",
    },
  },
  "confirm-reset-password": {
    "404": {
      summary: "Errore",
      detail: "Token non più valido",
    },
  },
  "api/auth/check-token": {
    "404": {
      summary: "Errore",
      detail: "Token non più valido",
    },
  },
  "api/auth/check-token-reset-password": {
    "404": {
      summary: "Errore",
      detail: "Token non più valido",
    },
  },
  "api/users/get-users": {},
  "api/users/add": {
    "403": {
      summary: "Errore",
      detail: "Dominio non consentito",
    },
    "404": {
      summary: "Errore",
      detail: "Email dominio non valido",
    },
  },
  "api/users/update": {
    "403": {
      summary: "Errore",
      detail: "Dominio non consentito",
    },
    "404": {
      summary: "Errore",
      detail: "Utente non trovato",
    },
    "409": {
      summary: "Errore",
      detail: "Dominio non consentito",
    },
  },
  "api/users/delete": {
    "403": {
      summary: "Errore",
      detail: "Non hai i permessi per eliminare l'utente",
    },
    "404": {
      summary: "Errore",
      detail: "Utente non trovato",
    },
  },
  "api/sources/delete": {
    "404": {
      summary: "Errore",
      detail: "Fonte non più presente",
    },
  },
  "api/projects/add-sources": {
    "404": {
      summary: "Errore",
      detail: "Progetto non trovato",
    },
  },
  "api/projects/codes-list": {
    "404": {
      summary: "Errore",
      detail: "Progetto non trovato",
    },
  },
  "api/projects/report": {
    "404": {
      summary: "Errore",
      detail: "Segnalazione non trovata",
    },
  },
  "api/sources/detail": {
    "404": {
      summary: "Errore",
      detail: "Progetto non trovato",
    },
  },
  "api/projects/accept-invitation": {
    "403": {
      summary: "Error",
      detail: "Invito non più valido",
    },
    "404": {
      summary: "Error",
      detail: "Progetto non trovato",
    },
  },
  "api/projects/pinned-answers": {
    "403": {
      summary: "Error",
      detail: "Non hai i permessi sul progetto",
    },
    "404": {
      summary: "Error",
      detail: "Progetto non trovato",
    },
  },
  "api/projects/pinned-answer-detail": {
    "403": {
      summary: "Error",
      detail: "Non hai i permessi sul progetto",
    },
    "404": {
      summary: "Error",
      detail: "Progetto non trovato",
    },
  },
  "api/projects/pin-answers": {
    "403": {
      summary: "Error",
      detail: "Non hai i permessi sul progetto",
    },
    "404": {
      summary: "Error",
      detail: "Progetto not trovato o risposta non trovata.",
    },
  },
  "api/projects/share": {
    "404": {
      summary: "Error",
      detail: "Progetto non trovato",
    },
  },
  "api/projects/share-pinned-answers": {
    "403": {
      summary: "Error",
      detail: "Non hai i permessi sul progetto",
    },
    "404": {
      summary: "Error",
      detail: "Risposta non trovata.",
    },
  },
  "api/projects/update-pinned-answer-detail": {
    "403": {
      summary: "Error",
      detail: "Non hai i permessi sul progetto",
    },
    "404": {
      summary: "Error",
      detail: "Risposta non trovata.",
    },
  },
  "api/projects/prompt": {
    "403": {
      summary: "Error",
      detail: "Non hai i permessi sul progetto",
    },
    "404": {
      summary: "Error",
      detail: "Progetto non trovato",
    },
  },
  "api/projects/code-detail": {
    "404": {
      summary: "Error",
      detail: "Fonte o progetto non trovato.",
    },
  },
  "api/projects/chat-history": {
    "403": {
      summary: "Error",
      detail: "Non hai i permessi sul progetto",
    },
    "404": {
      summary: "Error",
      detail: "Progetto not trovato o risposta non trovata.",
    },
  },
  "api/topic/delete": {
    "409": {
      summary: "Impossibile eliminare",
      detail: "Il topic è attualmente in uso in una o più fonti nell’archivio",
    },
    "404": {
      summary: "Error",
      detail: "Topic non trovato",
    },
  },
  "api/sources/download": {
    "404": {
      summary: "Impossibile scaricare",
      detail: "Il file non è più disponibile",
    },
  },
  "api/projects/check-source-status": {
    "404": {
      summary: "Error",
      detail: "Fonte non trovata",
    },
  },
  "api/projects/refresh-prompt": {
    "404": {
      summary: "Error",
      detail: "Fonte non trovata",
    },
  },
  "api/sources/retry": {
    "404": {
      summary: "Error",
      detail: "File/Fonte non trovato/a",
    },
  },
};
